// extracted by mini-css-extract-plugin
module.exports = {"verificationPage":"Verification_verificationPage__3pkn6","imgWrapper":"Verification_imgWrapper__ljI7S"};